// Auth guard for protecting routes
// Caches the result so we don't hit the API on every single navigation
let authChecked = false
let authResult = false

export async function checkAuth(): Promise<boolean> {
  // If we've already verified auth this session, use cached result
  if (authChecked) return authResult

  try {
    const response = await fetch('/api/auth/check/', {
      credentials: 'include'
    })

    if (!response.ok) {
      authChecked = true
      authResult = false
      return false
    }

    const data = await response.json()
    authChecked = true
    authResult = data.authenticated === true
    return authResult
  } catch (error) {
    console.error('Auth check failed:', error)
    authChecked = true
    authResult = false
    return false
  }
}

// Call this on logout to reset the cached auth state
export function resetAuthCache() {
  authChecked = false
  authResult = false
}

export function redirectToLogin() {
  // Redirect to Vue login page, then back to current page
  const returnUrl = encodeURIComponent(window.location.pathname + window.location.search)
  window.location.href = `/login?next=${returnUrl}`
}
